// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbFilledSvg from "@fishx/icons-svg/es/asn/UsbFilled";
import FishxIcon from '../components/FishxIcon';

var UsbFilled = function UsbFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbFilledSvg
  }));
};

UsbFilled.displayName = 'UsbFilled';
export default React.forwardRef(UsbFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UsbFilled.js
// module id = 4336
// module chunks = 0